import util from '@bmp-vue/core/api/util'

const controller = 'ActionGroupAccess'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GetAll: function (dto) {
    return util.Axios.Get(controller, dto)
  }
})
